import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const List = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.91667 6.25C3.60702 6.25 4.16667 5.69036 4.16667 5C4.16667 4.30964 3.60702 3.75 2.91667 3.75C2.22631 3.75 1.66667 4.30964 1.66667 5C1.66667 5.69036 2.22631 6.25 2.91667 6.25ZM7.26675 4.25C6.85254 4.25 6.51675 4.58579 6.51675 5C6.51675 5.41421 6.85254 5.75 7.26675 5.75H18.0001C18.4143 5.75 18.7501 5.41421 18.7501 5C18.7501 4.58579 18.4143 4.25 18.0001 4.25H7.26675ZM7.26675 9.65C6.85254 9.65 6.51675 9.98579 6.51675 10.4C6.51675 10.8142 6.85254 11.15 7.26675 11.15H18.0001C18.4143 11.15 18.7501 10.8142 18.7501 10.4C18.7501 9.98579 18.4143 9.65 18.0001 9.65H7.26675ZM7.26675 15.05C6.85254 15.05 6.51675 15.3858 6.51675 15.8C6.51675 16.2142 6.85254 16.55 7.26675 16.55H18.0001C18.4143 16.55 18.7501 16.2142 18.7501 15.8C18.7501 15.3858 18.4143 15.05 18.0001 15.05H7.26675ZM4.16667 10.4167C4.16667 11.107 3.60702 11.6667 2.91667 11.6667C2.22631 11.6667 1.66667 11.107 1.66667 10.4167C1.66667 9.72631 2.22631 9.16667 2.91667 9.16667C3.60702 9.16667 4.16667 9.72631 4.16667 10.4167ZM2.91667 17.0833C3.60702 17.0833 4.16667 16.5237 4.16667 15.8333C4.16667 15.143 3.60702 14.5833 2.91667 14.5833C2.22631 14.5833 1.66667 15.143 1.66667 15.8333C1.66667 16.5237 2.22631 17.0833 2.91667 17.0833Z"
        fill={color}
      />
    </svg>
  )
})

export default List
